// extracted by mini-css-extract-plugin
export default {"emphasis":"ChangePassword_emphasis__QQvbI"};